import {style} from 'typestyle'

export const  titleName =  style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    marginTop: 15,
    marginBottom: 14,
    paddingLeft: 15
})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommend/CategoryRecommend.style.ts